import React from 'react';
import styled from 'styled-components';
import { components } from 'react-select';
import type { OptionProps, OptionTypeBase } from 'react-select';
import { ICON_WRAPPER } from '../../../util/data-id';
import { CountryFlag } from '../../';

const CustomPhoneCodeOption: React.FC<OptionProps<OptionTypeBase, false>> = ({
  ...props
}) => {
  const { data: { label, value, iso2 } } = props;
  return (
    <>
      <components.Option {...props}>
        <OptionIconWrapper className={'mr-sm'}>
          <CountryFlag iso2={iso2} label={label} />
        </OptionIconWrapper>
        <div className={'w-full flex justify-between'}>
          <span>{label}</span>
          <span>{value}</span>
        </div>
      </components.Option>
    </>
  );
};

const OptionIconWrapper = styled('div')`
  [data-id='${ICON_WRAPPER}'] svg {
    margin-left: 0;
  }
`;

export default CustomPhoneCodeOption;
